import { motion } from "framer-motion";
import { ArrowDown, Plus } from "lucide-react";

export function Hero({ cardsCount, platforms, loading, onAdd, onBrowse }) {
  return (
    <section className="relative overflow-hidden pb-16 pt-28 md:pb-24 md:pt-36">
      <div className="relative mx-auto max-w-3xl px-5 text-center sm:px-8">
        <motion.img
          initial={{ opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          src="/logo.png"
          alt="Systech Aqua Solutions logo"
          data-testid="hero-logo"
          className="mx-auto h-20 w-20 object-contain mix-blend-multiply md:h-24 md:w-24"
        />

        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-6 font-mono text-[11px] tracking-[0.25em] text-ink/60"
        >
          SYSTECH AQUA SOLUTIONS
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.25 }}
          data-testid="hero-title"
          className="mt-4 font-display text-4xl font-extrabold leading-[1.05] tracking-[-0.02em] text-ink sm:text-5xl xl:text-6xl"
        >
          Every plant dashboard,
          <br />
          <span className="text-signal">one deck away.</span>
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.38 }}
          className="mt-9 flex flex-wrap items-center justify-center gap-4"
        >
          <button
            data-testid="hero-add-button"
            onClick={onAdd}
            className="group inline-flex items-center gap-2.5 bg-ink px-7 py-4 font-mono text-[11px] tracking-[0.22em] text-paper transition-colors duration-300 hover:bg-signal"
          >
            ADD DASHBOARD
            <Plus className="h-4 w-4 transition-transform duration-300 group-hover:rotate-90" />
          </button>
          <button
            data-testid="hero-browse-button"
            onClick={onBrowse}
            className="inline-flex items-center gap-2.5 border border-ink/25 px-7 py-4 font-mono text-[11px] tracking-[0.22em] text-ink transition-colors duration-300 hover:border-ink hover:bg-white"
          >
            BROWSE THE DECK
            <ArrowDown className="h-4 w-4" />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
